import {Box, Typography, Tooltip} from "@mui/material";
import {styled} from "@mui/system";

import {buildServiceTypeTooltip} from "../../helpers/ShiftPlanHelper";

const BookableServiceTypeText = styled(Typography)(() => ({
    variant: "body2",
    width: 50
}));

export default function ServiceTypeTooltipLabel({service, serviceTypePlans}) {
    return (
        <Tooltip title={<Box style={{whiteSpace: 'pre-line'}}>{buildServiceTypeTooltip(serviceTypePlans)}</Box>}>
            <BookableServiceTypeText>{service}</BookableServiceTypeText>
        </Tooltip>
    );
}
